<template>
<div>
    <Spinner v-if="!loaded" />
    <div class="table-responsive" v-else>
        <vue-good-table
            mode="remote"
            :columns="columns"
            :rows="rows"
            :total-rows="totalRows"
            :pagination-options="paginationOptions"
            @page-change="onPageChange"
            @per-page-change="onPerPageChange"
        >
            <template #table-row="props">
                <span v-if="props.column.field === 'amount'">
                    {{ props.row.currency__symbol }}{{ props.row.amount }}
                </span>
                <span v-else-if="props.column.field === 'status'">
                    <span :class="statusBadgeClass(props.row.status)">
                        {{ statusDisplay(props.row.status) }}
                    </span>
                </span>
                <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                </span>
            </template>
        </vue-good-table>
    </div>
</div>
</template>

<script>
import { toDateTime } from "utils/date";
import Spinner from "../Spinner.vue";

export default {
    components: {
        Spinner,
    },
    data() {
        return {
            loaded: false,
            columns: [
                { label: "ID", field: "id", sortable: false },
                { label: "Created at", field: "created_at", formatFn: toDateTime, sortable: false },
                { label: "Amount", field: "amount", sortable: false },
                { label: "Status", field: "status", sortable: false },
                { label: "Type", field: "kind", sortable: false },
                { label: "Plan", field: "plan__name", sortable: false },
            ],
            rows: [],
            totalRows: 0,
            serverParams: {
                page: 1,
                per_page: 50,
            },
        }
    },
    computed: {
        paginationOptions() {
            return {
                enabled: true,
                mode: 'pages',
                perPage: this.serverParams.per_page,
                perPageDropdown: [50, 100, 250, 500, 1000],
                dropdownAllowAll: false,
            }
        },
    },
    methods: {
        fetch() {
            this.$services.Transaction().get(this.serverParams).then(resp => {
                this.rows = resp.body.data || [];
                this.totalRows = resp.body.links?.pagination?.total || 0;
            }).finally(() => {
                this.loaded = true
            })
        },
        onPageChange(params) {
            this.serverParams.page = params.currentPage;
            this.fetch();
        },
        onPerPageChange(params) {
            this.serverParams.per_page = params.currentPerPage;
            this.serverParams.page = 1;
            this.fetch();
        },
        statusBadgeClass(status) {
            const s = String(status).toLowerCase()
            if (s === 'success' || s === '1') return 'badge bg-success'
            if (s === 'pending' || s === '0') return 'badge bg-warning'
            if (s === 'failed' || s === '2') return 'badge bg-danger'
            return 'badge bg-secondary'
        },
        statusDisplay(status) {
            const s = String(status).toLowerCase()
            if (s === '0') return 'Pending'
            if (s === '1') return 'Success'
            if (s === '2') return 'Failed'
            return status
        }
    },
    created() {
        this.fetch()
    }
}
</script>
